import { Autocomplete, Box, Button, Chip, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
import { Tag } from '../../models/tag';

interface TagSelectorProps {
  options: Tag[];
  label: string;
  onSearch: (tagIds: string[]) => void;
  loading?: boolean;
}

const TagSelector = ({ options, label, onSearch, loading }: TagSelectorProps) => {
  const [selectedTags, setSelectedTags] = useState<Tag[]>([]);

  const handleSearch = () => {
    const ids = selectedTags.map((t) => t.id);
    if (ids.length > 0) {
      onSearch(ids);
    }
  };

  return (
    <Box>
      <Autocomplete
        multiple
        options={options}
        getOptionLabel={(option) => option.name}
        value={selectedTags}
        onChange={(_, newValue) => setSelectedTags(newValue)}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => <Chip label={option.name} size="small" {...getTagProps({ index })} />)
        }
        renderInput={(params) => <TextField {...params} label={label} size="small" />}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        size="small"
        sx={{ mb: 1 }}
      />
      <Button
        variant="contained"
        startIcon={<SearchIcon />}
        onClick={handleSearch}
        disabled={selectedTags.length === 0 || loading}
        size="small"
      >
        {loading ? 'Hledám...' : 'Hledat recepty'}
      </Button>
    </Box>
  );
};

export default TagSelector;
